module.exports = __webpack_public_path__ + "static/coney-1a8d87298e47056b1eb44885c87cae13.jpg";